// extracted by mini-css-extract-plugin
module.exports = {"container":"os0anEMo57imNw4PAI0SO"};